import { takeLatest } from 'redux-saga/effects';

import {
    VALIDATE_AGENT_PROMOTION,
    SUBMIT_CLIENT_FROM_SHOP,
    MAIN_VALIDATE_FORM,
    SEND_RECOVERY_PASSWORD,
    DELETE_LOGIPARMA_DORMANT_CLIENT,
    DELETE_BOLT_DORMANT_CLIENT,
    GET_USER_AND_INACTIVE_INFO,
} from '../reducers';

import validateAgentPromotionSaga from "./validateAgentPromotionSaga";
import validateFormSaga from "./validateFormSaga";
import submitClientFromShopSaga from "./submitClientFromShopSaga";
import sendRecoveryPasswordSaga from "./sendRecoveryPasswordSaga";
import deleteLogiParmaDormantClientSaga from "./deleteLogiParmaDormantClientSaga";
import deleteBoltDormantClientSaga from "./deleteBoltDormantClientSaga";
import getUserAndInactiveInfoSaga from "./getUserAndInactiveInfoSaga";

export default function* mainSaga() {
    yield takeLatest(VALIDATE_AGENT_PROMOTION, validateAgentPromotionSaga);
    yield takeLatest(SUBMIT_CLIENT_FROM_SHOP, submitClientFromShopSaga);
    yield takeLatest(MAIN_VALIDATE_FORM, validateFormSaga);
    yield takeLatest(SEND_RECOVERY_PASSWORD, sendRecoveryPasswordSaga);
    yield takeLatest(DELETE_LOGIPARMA_DORMANT_CLIENT, deleteLogiParmaDormantClientSaga);
    yield takeLatest(DELETE_BOLT_DORMANT_CLIENT, deleteBoltDormantClientSaga);
    yield takeLatest(GET_USER_AND_INACTIVE_INFO, getUserAndInactiveInfoSaga);
}
